<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-text="处理中…… 请耐心等待"
    element-loading-spinner="el-icon-loading"
    class="touGeBox"
  >
    <!--    /* 轮播图 */-->
    <el-carousel height="520px">
      <el-carousel-item
        v-for="(item, index) in slideShowList"
        :key="index"
        style="height: 520px;"
      >
        <img
          @click="toDetail1(item.id,item)"
          :src="item.coverPic"
          style="height: 100%;width: 100%;cursor: pointer;"
        />
      </el-carousel-item>
    </el-carousel>
    <!--      柱状图-->
    <div class="systemBox">
      <el-button type="primary" style="background-color:#13499b;border: none;" @click="goSystem">进入系统</el-button>
    </div>
    <div class="chartBox">
      <div class="oneTitle">
        <div class="pubTitle">
          在线实验教学数据统计
        </div>
        <div class="pubTitles">
          —— Data statistics ——
        </div>
      </div>
      <div class="bar-chart" ref="chart" style="width: 100%; height: 500px;"></div>
    </div>
    <div class="backGroundDiv"></div>
    <div class="oneTitle">
      <div class="pubTitle">
        课程统计
      </div>
      <div class="pubTitles">
        —— Course statistics ——
      </div>
    </div>
    <div class="courseBox">
      <div class="courseTitleBox">
        <div v-for="(c,i) in courseList" :key="i" style="text-align: center" :class="activeTitleIndex==i?'activeTitleItem':'TitleItem'" @click="changeTitle(i,c)">
          <p class="Title">{{c.num}}</p>
          <p class="className">{{c.name}}</p>
        </div>
      </div>
      <div class="courseContent">
        <div v-for="(item,index) in total" :key="index" :class="activeCourseIndex==index?'activeCourseItem':'courseItem'" @click="changeActiveCourseItem(index)">
          <div class="itemTop">
            <img src="@/assets/2.png" alt="">
            <div class="subscript" v-if="activeTitleIndex==1||activeTitleIndex==0">国家一流</div>
            <div class="subscript1" v-if="activeTitleIndex==2">省级一流</div>
            <div class="subscript2" v-if="activeTitleIndex==3">其他课程</div>
          </div>
          <div class="itemBottom">
            <div class="itemTitle">
              <div style="width: 3%">
                <i class="dividerBlue"></i>
              </div>
              <div style="width:96%;padding-left: 3px;height: 100%">
                <div style="display: flex;align-items: center;justify-content: space-between">
                  <p style="font-size: 12px;margin-top: 2px;padding: 0">【国家一流】</p>
                  <p style="font-size: 14px;"><i class="el-icon-view" style="margin-right: 4px"></i>8998</p>
                </div>
                <div>
                  <p style="font-weight: 700;
                              font-size: 18px;
                              color: #333333;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              white-space: nowrap;

                      "> 大学计算——基于Python的计算思维与工…</p>
                  <!--                      文字超出两行显示省略号-->
                  <p style="font-size: 16px;
                                line-height: 30px;
                                margin-top: 12px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                word-break: break-all;
                                -webkit-box-orient: vertical
                            ">国防科技大学开设的“大学计算”课程借鉴 20学开设的“大学计算”课程借鉴12 年挪威教育质量保障局 NOKUT 资助…</p>
                </div>
                <hr style="border: 0;border-top: 2px dashed #f7f7f7;margin-top: 20px">
                <div style="display: flex;align-items: center;justify-content: space-between;padding: 0 30px;margin-top: 35px">
                  <div>
                    <p class="num">8000</p>
                    <p class="key">总计学生人数</p>
                  </div>
                  <div>
                    <p class="num">30</p>
                    <p class="key">实践项目</p>
                  </div>
                </div>
                <div style="display: flex;align-items: center;justify-content: space-between;padding: 0 30px;margin-top: 35px">
                  <div>
                    <p class="num">40</p>
                    <p class="key">选择题关卡</p>
                  </div>
                  <div>
                    <p class="num">50</p>
                    <p class="key">实践关卡</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="coursePage" style="text-align: center;margin: 20px 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[6]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 底部快捷链接 -->
    <div class="bottomLink">
      <div style="
            margin: 0 auto;display: flex;
            align-items: center;
            justify-content: center;
            width: 1300px;
            padding: 0 5%;
            height: 60px;
">
        <div
          v-for="(item, index) in friendshipLink.res"
          :key="index"
          class="bottomLinkList"
          :style="{cursor:item.linkName == '中心服务'?'default':'pointer'}"
          @click="goLink(item)"
        >
          <div style="display:flex;align-items: center;">
            <img
              :src="'/mainsys/UserFiles/externalicon/' + item.linkImage"
              style="height: 18px;width: 18px;margin-right:12px;"
            />
            <div style="line-height: 20px;height: 20px;">
              {{ item.linkName }}
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- 底部版权信息 -->
    <div class="copyDiv">
      <div style="width: 1300px;margin: 0 auto;display: flex;
          justify-content: space-between;
          align-items: center;">
        <div class="copyDivLeft">
          <img
            :src="require('../assets/bottomLogo.png')"
            alt=""
            style="width:360px;height:50px;margin-bottom:16px"
          />
          <div class="copyDivLeftCon">建设单位：国防科技大学</div>
          <div class="copyDivLeftCon">支持单位：湖南强智科技发展有限公司</div>
          <div class="copyDivLeftCon">
            推荐使用: Chrome或Firefox等主流浏览器
          </div>
          <div class="copyDivLeftCon">
            Copyright © 1999- 2024 国防科技大学 版权所有
          </div>
          <div class="copyDivLeftCon" style="display: flex;justify-content: space-between;align-items: center">
            <div style="height: 100px;line-height: 70px;">
              网站访问次数：{{websiteVisitsNum}} 次
            </div>
            <div id="chartLine"  style="width: 200px;height: 100px" ref="chartLine">

          </div>

<!--                        网站访问次数：{{websiteVisitsNum}} 次-->
          </div>
        </div>
        <div
          class="copyDivRight"
          style="text-align:center;width: 200px"
          v-if="friendshipLink.top && friendshipLink.top.length > 0"
        >
          <img
            :src="
              '/mainsys/UserFiles/externalicon/' +
                friendshipLink.top[0].linkImage
            "
            alt=""
            style="width:140px;height:140px;margin:0 auto;text-align: center"
          />
          <div style="font-size: 16px;color: #FAFAFA;margin-top: 16px">
            {{ friendshipLink.top[0].linkName }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: "TouGe",
  data() {
    return{
      fullscreenLoading:false,
      slideShowList:[],
      courseList:[
        {
          name:'全部课程',
          num:'6'
        },
        {
          name:'国家一流课程',
          num:'3'
        },
        {
          name:'省级一流课程',
          num:'2'
        },
        {
          name:'其他课程',
          num:'1'
        },
      ],
      websiteVisitsNum:'',
      activeTitleIndex:0,//课程分类默认选中
      activeCourseIndex:0,//课程默认选中
      currentPage:1,//当前页码
      pageSize:6,//每页显示多少条
      total:6,//总条数
      chart:null,//柱状图
      chartData:[],//柱状图数据
      chartXData:[],//柱状图X轴数据
      chartYData:[],//柱状图Y轴数据
      touGeUrl:"",
    }
  },
  methods:{
    goSystem(){
      window.open(this.touGeUrl);
      // window.location.href = this.touGeUrl
    },
    getAccessLogNum(){
      axios
        .post("/cmsapi/getAccessLogNum").then((res)=>{
        if(res.data.code == '2'){
          this.websiteVisitsNum = res.data.data
        }
      })
    },
    getSlideShow() {
      //获取轮播图
      axios.post("/cmsapi/getSlideshow").then(response => {
        let recData = response.data;
        this.slideShowList = recData;
        if (this.slideShowList.length > 0) {
          for (var i = 0; i < this.slideShowList.length; i++) {
            this.slideShowList[i].coverPic =
              "/mainsys/UserFiles/coverpic/" + this.slideShowList[i].coverPic;
          }
        } else {
          this.slideShowList = [
            {
              coverPic: require("../assets/banner.jpg")
            },
            {
              coverPic: require("../assets/banner.jpg")
            },
            {
              coverPic: require("../assets/banner.jpg")
            },
            {
              coverPic: require("../assets/banner.jpg")
            },
            {
              coverPic: require("../assets/banner.jpg")
            }
          ];
        }
      });
    },
    getMyChart() {
      const chartDom = this.$refs.chart;
      const myChart = echarts.init(chartDom);
      // 指定图表的配置项和数据
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
        },
        xAxis: {
          data: ['实践课程数', '实践项目数', '教学课堂数', '考试数量', '试题数量', ],
          axisTick: {
            show: false  // 隐藏坐标轴刻度线
          },
        },
        yAxis: {},
        series: [{
          name: '销量',
          type: 'bar',
          data: [120, 200, 150, 80, 70, 110, 130],
          barWidth: 40,
          // itemStyle: {
          //   // 修改柱子颜色
          //   color: '#03a9f4'
          // }
        }]
      };
      myChart.setOption(option);
    },
    getMyChartLine(){
      const chartDom = this.$refs.chartLine;
      const myChart = echarts.init(chartDom);
     const option = {
       xAxis: [{
         type: 'category',
         axisLabel: {//坐标轴刻度标签
           show: false
         },
         axisLine: {//坐标轴轴线
           show: false
         },
         axisTick: {//坐标轴刻度
           show: false
         }
       }],
        yAxis: {
          type: 'value',
          splitLine: {//坐标轴在grid区域中的分割线
            show: false
          },
          axisLabel: {//坐标轴刻度标签
            show: false
          },
        },
       grid: {
          left: '0%',
         top:'20%',
         // bottom: '3%',
       },
        series: [
          {
            data: [50, 330, 64, 508,50, 330, 64],
            type: 'line'
          }
        ]
      };
      myChart.setOption(option);

    },
    toDetail1(){},
    changeTitle(index,c){
      this.activeTitleIndex = index
      this.total=c.num-0
    },
    changeActiveCourseItem(index){
      this.activeCourseIndex = index
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
        this.currentPage = val;
    },
  },
  mounted() {
    this.touGeUrl = this.$route.query.url
    this.getSlideShow()
    this.getMyChart()
    this.getMyChartLine()
    this.getAccessLogNum()
  }
}
</script>



<style scoped lang="less">
.touGeBox{
  height: calc(100%- 170px);
  position: relative;
  .chartBox{
    width: 1200px;
    margin: 0 auto;
    background: rgba(255,255,255,0.5);
    .bar-chart {
      margin: 20px auto;
    }
  }
  .pubTitle {
    margin-top: 10px;
    font-weight: 700;
    font-size: 30px;
    color: #13499b;
    letter-spacing: 4px;
    text-align: center;
  }
  .backGroundDiv{
    position: absolute;
    width: 100%;
    background-size: 100% auto;
    background: url("../assets/TouGe/banner.png") no-repeat center;
    z-index: -99;
    height: 1800px;
    top: 500px;
  }
  .courseBox{
    width: 1200px;
    margin:  0 auto;
    //height: 100%;
    .courseTitleBox{
      margin-top: 15px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #fff;
      height: 100px;
      border-bottom: 1px solid #c3c7d0;
      cursor: pointer;
      .activeTitleItem{
        width: 25%;
        height: 100%;
        background-color: #f1f4f9;
        padding-top: 20px;
        border-bottom: 3px solid #002b9e;
        padding-bottom: -1px;
        .Title{
          font-size: 22px;
          font-weight: 700;
          color: #002b9e;
        }
        .className{
          margin-top: 10px;
        }
      }
      .TitleItem{
        width: 25%;
        padding-top: 20px;
        height: 100%;
        .Title{
          font-size: 22px;
          font-weight: 700;
          color: #002b9e;
        }
        .className{
          margin-top: 10px;
        }
      }
    }
    .TitleItem:hover{
      width: 25%;
      height: 100%;
      background-color: #f1f4f9;
      padding-top: 20px;
      border-bottom: 3px solid #002b9e;
      padding-bottom: -1px;
      .Title{
        font-size: 22px;
        font-weight: 700;
        color: #002b9e;
      }
      .className{
        margin-top: 10px;
      }
    }
    .courseContent{
      margin-top: 25px;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      //justify-content: space-between;
      .courseItem{
        margin-bottom: 20px;
        height: 500px;
        width: 380px;
        margin-right: 30px;
        cursor: pointer;
        img{
          width: 100%;
          height: 150px;
        }
        .itemBottom{
          padding: 10px 15px;
          height: 350px;
          width: 100%;
          background-color: #fff;
          .itemTitle{
            width: 100%;
            display: flex;
            //align-items: center;
            //justify-content: space-between;
          }
          .num{
            color: #002b9e;
            font-weight: 700;
            font-size: 18px;
          }
          .key{
            color: #666;
            margin-top: 6px;
          }
        }
      }
    }
    .courseItem:hover .itemBottom{
      color: #fff;
      background-color:#13499b !important;
      p{
        color: #fff !important;
      }
    }
    .activeCourseItem{
      color: #fff !important;
      background-color:#13499b !important;
      margin-bottom: 20px;
      height: 500px;
      width: 380px;
      margin-right: 30px;
      cursor: pointer;
      img{
        width: 100%;
        height: 150px;
      }
      .itemBottom{
        padding: 10px 15px;
        height: 350px;
        width: 100%;
        .itemTitle{
          width: 100%;
          display: flex;
          //align-items: center;
          //justify-content: space-between;
        }
        .num{
          font-weight: 700;
          font-size: 18px;
        }
        .key{
          margin-top: 6px;
        }
      }
      p{
        color: #fff !important;
      }
    }
    .dividerBlue{
      display: block;
      width: 2px;
      height: 40px;
      background-color: #13499b;
    }
    .dividerYellow{
      display: block;
      width: 2px;
      height: 40px;
      background-color: #ba7915;
    }
    .dividerGreen{
      display: block;
      width: 2px;
      height: 40px;
      background-color: #57a7ae;
    }
    .courseItem:nth-child(3n){
      margin-right: 0 !important;
    }
    .activeCourseItem:nth-child(3n){
      margin-right: 0 !important;
    }
    .itemTop{
      position: relative;
    }
    .subscript{
      position: absolute;
      top: 0;
      left: 0;
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 0 0 16px 0;
      background-color: #13499b;
      color: #fff;
    }
    .subscript1{
      position: absolute;
      top: 0;
      left: 0;
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 0 0 16px 0;
      background-color: #bb7915;
      color: #fff;
    }
    .subscript2{
      position: absolute;
      top: 0;
      left: 0;
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 0 0 16px 0;
      background-color: #56a7af;
      color: #fff;
    }
  }
  .pubTitles {
    color: #13499b;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
  }
  .oneTitle {
    //height: 100%;
    width: 400px;
    height: 120px;
    padding-top: 15px;
    background: url("../assets/title.png") no-repeat center;
    margin: auto;
  }
  .systemBox{
    position: absolute;
    right: 100px;
    top: 550px;
    color: #002b9e;
    font-size: 20px;
    cursor: pointer;
  }
}
.bottomLink {
  height: 60px;
  /* width: calc(100% - 520px); */
  background: #0d3b80;
  color: #fff;
  padding: 0 260px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bottomLinkList {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 280px;
  position: relative;
}
.bottomLinkList:not(:last-child)::after {
  content: "";
  width: 1px;
  height: 24px;
  opacity: 0.2;
  background-color: #fff;
  position: absolute;
  right: 0;
}
.linkDivider .el-divider--vertical {
  height: 24px !important;
  background-color: #3f6bae !important;
  width: 1.5px !important;
  margin: 0 30px 36px 30px !important;
}
.copyDiv {
  height: 400px;
  /* width: calc(100% - 520px); */
  padding: 45px 260px;
  background: url("../assets/bottomBg.jpg") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.copyDivLeftCon {
  opacity: 0.8;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  margin-top: 16px;
}
</style>
